/* Notivo Warenkorb: Zusatzprodukte aus der Schublade hinzufügen, "Weiter einkaufen", Ladezustand des Kassen-Buttons. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  window.checkoutLoad = function (event) {
    var btn = event && event.currentTarget;
    if (!btn) return;
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
    setTimeout(function () {
      if (window.location.pathname.indexOf('/checkout') > -1) return;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }, 8000);
  };

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-nv-cart-close]');
    if (close) {
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
      return;
    }

    // Variante eines Stücks wechseln (bei Menge 1 die ganze Zeile, sonst ein Stück abspalten)
    var swap = event.target.closest('[data-nv-swap]');
    if (swap) {
      event.preventDefault();
      if (swap.classList.contains('is-loading')) return;
      var box = swap.closest('.nv-cart__swap');
      var select = box && box.querySelector('[data-nv-swap-select]');
      var fromId = Number(swap.getAttribute('data-nv-swap'));
      var qty = Number(swap.getAttribute('data-nv-swap-qty')) || 1;
      var toId = select ? Number(select.value) : 0;
      if (!fromId || !toId || fromId === toId) return;
      var cartEl = drawer();
      var existing = document.querySelector('cart-drawer .quantity__input[data-quantity-variant-id="' + toId + '"]');
      var toQty = (existing ? Number(existing.value) : 0) + 1;
      var updates = {};
      updates[fromId] = qty > 1 ? qty - 1 : 0;
      updates[toId] = toQty;
      var payload = { updates: updates };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        payload.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      swap.classList.add('is-loading');
      fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) { swap.classList.add('is-error'); return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nv-cart' });
          }
          if (cartEl && data.sections && typeof cartEl.renderContents === 'function') cartEl.renderContents(data);
          else window.location.reload();
        })
        .catch(function () { swap.classList.add('is-error'); })
        .finally(function () { swap.classList.remove('is-loading'); });
      return;
    }

    var add = event.target.closest('[data-nv-cart-add]');
    if (!add) return;
    event.preventDefault();
    if (add.classList.contains('is-loading')) return;

    var cart = drawer();
    var body = { items: [{ id: Number(add.getAttribute('data-nv-cart-add')), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    add.classList.add('is-loading');
    add.setAttribute('aria-busy', 'true');

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          add.classList.add('is-error');
          setTimeout(function () { add.classList.remove('is-error'); }, 2500);
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nv-cart' });
        }
        if (cart && data.sections && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        add.classList.add('is-error');
        setTimeout(function () { add.classList.remove('is-error'); }, 2500);
      })
      .finally(function () {
        add.classList.remove('is-loading');
        add.removeAttribute('aria-busy');
      });
  });
})();
